<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        WebShell 상세 정보
        </h4>
        <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
            <a href="#">
              <i class="fas fa-home text-muted"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a class="font_15 font-weight-bold" href="#">WebShell 상세 정보</a>
          </li>
        </ul>
      </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              제출 세부사항
            </div>
            <div class="mb7">
              <span class="float-right"> {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_status">
                상태
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-2">
              <!-- <b-badge variant="success" v-if="model.is_done">완료</b-badge>
              <b-badge v-else variant="secondary">대기</b-badge> -->
              <b-badge v-if="model.is_del" variant="danger">삭제</b-badge>
              <b-badge v-else :variant="model.is_done ? 'success' : 'secondary'">{{model.is_done ? '완료' : '대기'}}</b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_source">
                출처 [사용자 등록 요청]
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.source">{{model.source}}</div>
            </b-col>
          </b-row>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_type">
                콘텐츠 타입
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.category" v-html="model.category"></div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_ext">
                콘텐츠 확장
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.ext" v-html="model.ext"></div>
            </b-col>
          </b-row>
          <b-row class="row mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_filename">
                파일 이름
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <div v-if="model && model.name" v-html="model.name"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-12 col-md-12">
              <b-button class="float-right" size="sm" variant="warning" @click="decrypt" :disabled="decrypted">
                base64 강제 디코딩
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
            <b-form-group>
              <hr>
              <label for="ph_descript">내용</label>
              <span v-if="model && model.length">( bytes : {{model.length}} )</span>
              <div v-if="model && model.data" v-html="content || model.data || 'None'" style="padding:15px;background:#f5f5f5;border:1px solid #ccc;border-radius:5px;"></div>
            </b-form-group>
            </b-col>
          </b-row>
          <b-form>
            <b-button size="sm" variant="danger" @click="remove_confirm = true" style="margin:0 5px;" :disabled="model.is_del"> 삭제 </b-button>
            <b-button size="sm" variant="add" @click="regist_confirm = true" style="margin:0 5px;" :disabled="model.is_del"> 패턴 등록 </b-button>
            <b-button size="sm" variant="primary" @click="download" style="margin:0 5px;"> 다운로드 </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Webshell 삭제"  class="modal-danger" v-model="remove_confirm" @ok="remove" ok-variant="outline-danger" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소" header-bg-variant="danger">
      해당 정보를 삭제하시겠습니까?
    </b-modal>
    <b-modal title="Webshell 등록"  class="modal-warning" v-model="regist_confirm" @ok="add" ok-variant="outline-warning" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소" header-bg-variant="warning">
      패턴으로 등록하시겠습니까?
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>